import React from "react";
import { createRoot } from "react-dom/client";
// Astryx: a ordem importa — 1º a declaração das cascade layers, depois os CSS
// do Astryx (@layer reset/astryx-base/astryx-theme) e por fim o index.css
// (Tailwind embrulhado em tw-base/tw-components/tw-utilities).
import "./theme/astryx-layers.css";
import "@astryxdesign/core/reset.css";
import "@astryxdesign/core/astryx.css";
import "@astryxdesign/theme-neutral/theme.css";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
